<template>
  <div>
    <el-row >
      <el-col :span="24">
        <el-card>
          <div slot="header" class="flex justify-between">
            <span>查询条件</span>
          </div>
          <el-row :gutter="20">
            <el-col :span="4">
              <el-input v-model="conditions.levelName" placeholder="请输入会员名称" clearable />
            </el-col>
            <el-col :span="4">
              <el-select v-model="conditions.vipLevel" placeholder="请选择会员等级" style="width:100%" clearable>
                <el-option v-for="item in vipLevels" :key="item.statusCd" :label="item.name" :value="item.statusCd" />
              </el-select>
            </el-col>
            <el-col :span="4">
              <el-input v-model="conditions.vipLevelId" placeholder="请输入等级编号" clearable />
            </el-col>
            <el-col :span="4">
              <el-button type="primary" icon="el-icon-search" @click="queryShopVipLevelMethod">查询</el-button>
              <el-button icon="el-icon-refresh" @click="resetShopVipLevelMethod">重置</el-button>
            </el-col>
          </el-row>
        </el-card>
      </el-col>
    </el-row>

    <el-row class="margin-top">
      <el-col :span="24">
        <el-card>
          <div slot="header" class="flex justify-between">
            <span>会员等级</span>
            <el-button type="primary" icon="el-icon-plus" size="small" style="float:right"
              @click="openAddShopVipLevelModal">添加等级</el-button>
          </div>
          <el-table :data="shopVipLevels" border style="width:100%">
            <el-table-column prop="levelName" label="会员名称" align="center" />
            <el-table-column prop="vipLevelName" label="会员等级" align="center" />
            <el-table-column prop="remark" label="说明" align="center" />
            <el-table-column prop="createTime" label="创建时间" align="center" />
            <el-table-column label="操作" align="center" width="200">
              <template slot-scope="scope">
                <el-button size="mini" @click="openEditShopVipLevelModel(scope.row)">修改</el-button>
                <el-button size="mini" type="danger" @click="openDeleteShopVipLevelModel(scope.row)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination :current-page="page" :page-size="rows" :total="total"
            layout="total, sizes, prev, pager, next, jumper" @current-change="handlePageChange" />
          <div class="margin-top">
            <span>会员等级从大到小依次为：一级、二级、三级</span>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <add-shop-vip-level  ref="addShopVipLevel" @refresh="listShopVipLevels"/>
    <edit-shop-vip-level  ref="editShopVipLevel" @refresh="listShopVipLevels" />
    <delete-shop-vip-level ref="deleteShopVipLevel" @refresh="listShopVipLevels" />
    <choose-coupon-shop-pool ref="chooseCouponShopPool"  @refresh="listShopVipLevels"/>
  </div>
</template>

<script>
import { getDict } from '@/api/shop/shopApi'
import { getShopId } from '@/api/shop/shopApi'
import { queryShopVipLevel } from '@/api/user/shopVipLevelApi'
import AddShopVipLevel from '@/components/user/addShopVipLevel/addShopVipLevel'
import EditShopVipLevel from '@/components/user/editShopVipLevel/editShopVipLevel'
import DeleteShopVipLevel from '@/components/user/deleteShopVipLevel/deleteShopVipLevel'
import ChooseCouponShopPool from '@/components/goods/chooseCouponShopPool/chooseCouponShopPool'

export default {
  name: 'ShopVipLevel',
  components: {
    AddShopVipLevel,
    EditShopVipLevel,
    DeleteShopVipLevel,
    ChooseCouponShopPool
  },
  data() {
    return {
      shopVipLevels: [],
      total: 0,
      page: 1,
      rows: 10,
      vipLevels: [],
      conditions: {
        levelName: '',
        vipLevel: '',
        vipLevelId: '',
        shopId: ''
      }
    }
  },
  created() {
    this.listShopVipLevels()
    this.getVipLevelDict()
  },
  methods: {
    async listShopVipLevels() {
      try {
        let shopId = await getShopId();
        this.conditions.shopId = shopId
        const res = await queryShopVipLevel({
          ...this.conditions,
          page: this.page,
          row: this.rows
        })
        this.shopVipLevels = res.data
        this.total = res.total
      } catch (error) {
        console.error(error)
      }
    },
    async getVipLevelDict() {
      try {
        const { data } = await getDict('s_shop_vip_level', 'vip_level')
        this.vipLevels = data
      } catch (error) {
        console.error(error)
      }
    },
    queryShopVipLevelMethod() {
      this.page = 1
      this.listShopVipLevels()
    },
    resetShopVipLevelMethod() {
      this.conditions = {
        levelName: '',
        vipLevel: '',
        vipLevelId: '',
        shopId: ''
      }
      this.listShopVipLevels()
    },
    openAddShopVipLevelModal() {
      this.componentShow = 'addShopVipLevel'
      this.$nextTick(() => {
        this.$refs.addShopVipLevel.open()
      })
    },
    openEditShopVipLevelModel(row) {
      this.componentShow = 'editShopVipLevel'
      this.$nextTick(() => {
        this.$refs.editShopVipLevel.open(row)
      })
    },
    openDeleteShopVipLevelModel(row) {
      this.$refs.deleteShopVipLevel.open(row)
    },
    handlePageChange(val) {
      this.page = val
      this.listShopVipLevels()
    }
  }
}
</script>

<style scoped>
.margin-top {
  margin-top: 20px;
}
</style>